// extracted by mini-css-extract-plugin
export default {"fadeIn":"Animations_fadeIn__o5uJ4"};